import Component from "../../lib/component";
import {TogglerPane} from "./toggler_pane";

export const TogglerBtnConfig = {
    componentTypeKey: 'TogglerBtn',
    baseHtmlClass: 'toggler_btn',
    selector: '.toggler_btn',

    targetIdDatasetKey: 'toggler_btn__target_pane_id',
};

function getTogglerPane(togglerBtn) {
    const targetPaneElementId = togglerBtn.element.dataset[TogglerBtnConfig.targetIdDatasetKey];
    const target_el = document.getElementById(targetPaneElementId);
    if (target_el) return new TogglerPane(target_el, togglerBtn, togglerBtn.togglerBtns);
}

export class TogglerBtn extends Component {

    constructor(id_or_element, togglerBtns) {
        super({
            element: id_or_element,
            config: TogglerBtnConfig
        });

        this.togglerBtns = togglerBtns;
        this.isActive = this.element.classList.contains('active') || this.hasHtmlClassState('active');
        this.togglerPane = getTogglerPane(this);

        this.element?.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.togglerBtns.activateBtn(this);
        });

        this.render();
    }

    activate() {
        this.isActive = true;
        this.render();
        if (this.togglerPane) this.togglerPane.activate();
    }

    deactivate() {
        this.isActive = false;
        this.render();
        if (this.togglerPane) this.togglerPane.deactivate();
    }

    render() {
        if (this.isActive) {
            this.element?.classList.add('active');
        } else {
            this.element?.classList.remove('active');
        }

        this.conditionallySetHtmlClassState(this.isActive, 'active');
    }

}